import styled from "styled-components";

export const Container = styled.div`
width: 100%;
height: 100vh;
margin: 0;
padding: 0;
// background-image: linear-gradient( 109.6deg,  rgba(102,203,149,1) 11.2%, rgba(39,210,175,1) 98.7% );
// background: #c1bfca;
// background:#ccbce6;
overflow:hidden;
@media only screen and (max-width: 728px) {
height:100%;
  }
`;

export const HomeImageContainer = styled.div`
width: 500px;
 float: right;
 @media only screen and (max-width: 768px) {
    width: 350px;
      }
`;

export const HomeRowContainer = styled.div`
width: 100%;
height: 70%;
display: flex;
align-items: center;
padding: 2rem 0 0 2rem;
.home-main-head{
font-size: 38px;
font-weight: 900;
color: #232323c7;
}
.home-description{
font-size: 15px;
font-weight: 400;
color: #000000ad
}
img{
    width:100%;
}
.divider{
    color: rgb(0 0 0 / 35%);
    font-weight: 500;
    font-size: 12px;
    // margin: 2.5rem 0 2rem 0;
    font-family: 'Roboto', sans-serif;
}

.submit-button{
    background-image: linear-gradient(to right,#41d4b3, #067D68);
    border:none;
    outline:none !important;
    width: 100%;
    height: 40px;
    font-size: 15px;
    font-weight: 600;
    box-shadow: rgb(0 0 0 / 20%) 0px 35px 40px -7px;
    // margin:10px 0px;
    margin: 12px 0px 2rem 0px;
    &:active{
        border:none !important;
        box-shadow: rgb(0 0 0 / 20%) 0px 35px 40px -7px !important;
    }
}
.form-control{
    font-size: 14px !important;
    font-family: 'Roboto', sans-serif;
    font-weight:500;
    background-color: #e1f4ff8c !important;
    border:none !important;
    padding: 20px;
    margin: 20px 0px;
    &:focus{
    // border-color: #80bdff;
    border:none !important;
    box-shadow: none !important;
    }
}
.form-group{
    position:relative;
   .fa-icon{
    position: absolute;
    right: 8px;
    bottom: 13px;
    font-size: 13px;
    color: #0a836d52;
    }
}
`;

export const UserDetailsCard = styled.div`
display: flex;
flex-direction: column;
align-items: center;
box-shadow: rgb(0 0 0 / 10%) 0px 10px 50px;
padding: 2rem 0;
border-radius: 15px;
.img-div{
    // border-radius: 50%;
     width: 150px;
     padding-bottom:1rem;
     img{
         width:100%;
     }
}
.welcome-text{
font-size: 16px;
font-weight: 400;
color: rgb(64 64 64);
font-family: Roboto;
span{
font-size: 18px;
font-weight: 600;
padding-left: 5px;
color: rgb(64 64 64);
}
}
.user-email{
font-family: Roboto;
font-size: 14px;
font-weight: 600;
color: rgb(64 64 64);
}
`;

export const LogSuggestion = styled.p`
font-size: 12px;
color: #19191978;
margin: 10px 0px;
text-align: center;
font-weight: 500;
color: rgb(0 0 0 / 35%);
span{
    font-size: 13px;
    color: #17967e;
    padding-left: 5px;
    cursor:pointer;
}
`;

export const HomeSignContainer = styled.div`
display: flex;
align-items: center;
justify-content: center;
margin-top: 20px;
.google-icon{
    width: 45px;
    border: 1px solid #0f8b742b;
    padding: 10px;
    border-radius: 9px;
    img{
        width:100%;
    }
    &:hover{
    background: white;
    border: 1px solid #0f8b7400;
    box-shadow: rgb(149 157 165 / 20%) 0px 8px 24px;
    }
}
`;

export const HomeConnectButton = styled.button`
border: none;
outline: none;
border-radius: 5px;
width: ${props => props.width ? props.width : '180px'};
height: ${props => props.height ? props.height : '40px'};
font-size: ${props => props.fontsize ? props.fontsize : '15px'};
font-weight: 600;
// background: #2b2b2b;
// background: #067D68;
background-image: linear-gradient(to right,#41d4b3, #067D68);
color: white;
margin-top: 10px;
box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px, rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px, rgba(0, 0, 0, 0.07) 0px 16px 16px;
`;

export const DashboardContainer = styled.div`
width: 100%;
height: 100vh;
margin: 0;
padding: 0;
`;

export const DashMainWrapper = styled.div`
width: 100%;
height: 85%;
padding: 1rem 2rem;
display:flex;
justify-content: center;
overflow-y:auto;
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
    }
    .profile-view-container{
      width: 50%;
      padding: 0 1rem;
      img{
        width:100%;
        border-radius:50%;
    }
    .prof-img-div{
        width: 100px;
    }
    .prof-details-div{
        margin-left: 20px;
        .prof-usename{
            font-size: 20px;
            font-weight: 900;
        }
        .prof-email{
            font-size: 14px;
             font-weight: 400;
        }
    }
    }
`;

export const HomeActionCard = styled.div`
padding: 20px;
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
// box-shadow: rgb(0 0 0 / 20%) 0px 20px 30px;
p{
    font-family: Roboto;
    font-size: 15px;
    font-weight: 500;
    color: rgba(35, 35, 35, 0.78);
}

@media only screen and (max-width: 425px) {
    margin:1rem 0;
      }
`;

export const DashProfContainer = styled.div`
display: flex;
align-items: center;
.file-upload-label{
    outline: none;
    border: 1px solid rgba(150,142,142,0.5);
    background: white;
    font-size: 14px;
    color: black;
    font-weight: 500;
    padding: 5px 20px;
    border-radius: 5px;
    margin-left:12px;
}
`;

export const DashButtons = styled.button`
outline: none;
border: ${props => props.transparent ? '1px solid rgba(150, 142, 142, 0.5)' : 'none '};
background: ${props => props.transparent ? 'white' : 'rgb(0, 0, 0) '} ;
font-size: 14px;
color:${props => props.transparent ? 'black' : 'white '} ;
font-weight: 500;
padding: 5px 20px;
border-radius: 5px;
`;

export const DashFormDiv = styled.div`
padding: 1rem;
label{
    font-size: 12px;
    font-weight: 600;
    margin-top: 10px;
}
input{
    font-size: 14px;
    font-weight: 700;
}
`;

export const DashCalenderDiv = styled.div`
width: 70%;
padding: 0px 1rem;
.prof-usename{
    font-size: 20px;
    font-weight: 900;
    text-align: center;
    width: 100%;
    background-image: linear-gradient(to right,#41d4b3,#067D68);
    color: white;
    padding: 5px;
    border-radius: 5px;
}
`;

export const EventsViewLinkButton = styled.div`
position: fixed;
bottom: 3rem;
right: 2.5rem;
background-image: linear-gradient(to right,#41d4b3,#067D68);
box-shadow: rgb(136 165 191 / 48%) 6px 2px 16px 0px, rgb(255 255 255 / 80%) -6px -2px 16px 0px;
color: white;
height: 50px;
width: 50px;
display: flex;
align-items: center;
justify-content: center;
border-radius: 25px;
a{
    color:white;
    text-decoration:none;
    &:hover{
        color:white;
    }
}
    `;
